import React, { useContext, useState } from 'react'
import { CheckOutContext } from '../../Context/CheckOutContext.jsx'
import ReviewModal from '../ReviewModal/ReviewModal.jsx';
import { AiFillCaretDown } from 'react-icons/ai';
import CancelOrderModal from '../CancelOrderModal/CancelOrderModal.jsx';
import { Link } from 'react-router-dom';
import emptyWish from "./../../assets/empty-state-cart.svg";
import { Helmet, HelmetProvider } from 'react-helmet-async';

const Orders = () => {

    const { orders } = useContext(CheckOutContext)
    const [showReviewModal, setShowReviewModal] = useState(false)
    const [showCancelModal, setShowCancelModal] = useState(false)
    const [prodId, setProdId] = useState('')
    const [orderId, setOrderId] = useState('')

    const handleCloseModal = () => setShowReviewModal(false)

    const handleCloseCancelModal = () => setShowCancelModal(false)

    const getProdId = (id) => setProdId(id)


    return (
        <HelmetProvider>
            <Helmet>
                <title>FreshCart | Orders</title>
            </Helmet>
            <div className="p-5">
                <h2 className="text-3xl font-medium text-center my-5">Orders</h2>
                <div className="flex gap-4 flex-col">
                    {orders?.length ? orders.map((order, i) =>
                        <div key={i} className="order border border-gray-400 rounded-md p-2 bg-gray-100">
                            <h3 className="text-lg uppercase font-semibold text-green-700">Order {i + 1}</h3>
                            <div className="info grid grid-cols-1 sm:grid-cols-2 gap-2 my-4 text">
                                <p className="text-base font-medium">Address : <span className="text-slate-500">{order.address}</span></p>
                                <p className="text-base font-medium">Ordered at : <span className="text-slate-500">{order.createdAt.split("T").slice(0, 1)}</span></p>
                                <p className="text-base font-medium">Status : <span className="text-slate-500">{order.orderStatus}</span></p>
                                <p className="text-base font-medium">Payment Method : <span className="text-slate-500">{order.paymentMethod}</span></p>
                                <p className="text-base font-medium">subTotal : <span className="text-slate-500">{order.subTotal} EGP</span></p>
                                <p className="text-base font-medium">Price After Discount : <span className="text-slate-500">{order.totalPrice} EGP</span></p>
                            </div>
                            <h3 className="text-base uppercase font-semibold text-green-700 my-5">Products <AiFillCaretDown className='inline-block' size={22} /></h3>
                            <div className="products grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4 p-2">
                                {order.products?.map((product, i) =>
                                    <div key={i} className="product flex flex-col lg:flex-row gap-4 border p-2 rounded-md border-slate-300">
                                        <Link to={`/products/${product.productId._id}`} className="md:max-w-[150px] max-w-[200px] m-auto">
                                            <img src={product.productId?.mainImage?.path} alt="Product_Image" />
                                        </Link>
                                        <div className="flex flex-col justify-center">
                                            <h3 className="text-lg font-medium">{product.name.charAt(0).toUpperCase() + product.name.slice(1)}</h3>
                                            <p className="text-base font-medium">Price : <span className="text-slate-500">{product.productPrice.toFixed(2)} EGP</span></p>
                                            <p className="text-base font-medium">Quantity: <span className="text-slate-500">{product.quantity} Item</span></p>
                                            <div className="my-4">
                                                <button onClick={() => { setShowReviewModal(true); getProdId(product.productId._id) }} className='bg-blue-600 py-2 w-full sm:w-1/2 rounded text-white hover:bg-blue-500 transition'>Review</button>
                                                <ReviewModal productId={prodId} onClose={handleCloseModal} visible={showReviewModal} />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <button onClick={() => { setShowCancelModal(true); setOrderId(order._id) }} className='bg-red-600 text-white w-50 py-2 px-8 my-4 float-right rounded hover:bg-red-500'>Cancel Order</button>
                            <CancelOrderModal orderId={orderId} onClose={handleCloseCancelModal} visible={showCancelModal} />
                        </div>
                    ) : <div className='container min-h-96 '>
                        <div className="flex flex-wrap gap-4 h-full flex-col justify-center items-center p-3 text-center">
                            <div className="img-box mt-10">
                                <img src={emptyWish} alt="" />
                            </div>
                            <p className="text-2xl font-medium">No Orders Yet</p>
                            <p className="text-slate-500 text-base">Explore More and Buy some items</p>
                            <Link to="/" className='bg-green-500 text-slate-50 rounded py-2 px-6 text-sm uppercase font-bold  hover:bg-green-700'>Start Shopping</Link>
                        </div>
                    </div>}
                </div>
            </div>
        </HelmetProvider>
    )
}

export default Orders